import { createElement as rc } from 'react';
import {
    View,
    Text,
    Switch,
    fromTheme,
    styled,
    testProperties,
    nativeOnlyStyles,
    webOnlyStyles
} from 'lib_ui-primitives';

let SwitchLayout = styled(View).attrs({ name: 'switch-layout' })`
    display: flex;
    flex-direction: row;
    align-items: center;
    column-gap: ${({ size = 'sm' }) => fromTheme('switch', 'options', 'gap', size)};
`;
SwitchLayout.displayName = 'SwitchLayout';

const SwitchWithMargin = styled(Switch).attrs({ name: 'switch-with-margin' })`
    flex-grow: 0;
    margin-left: ${({ size = 'sm' }) => fromTheme('switch', 'track', 'margin', size, 'left')};
    margin-right: ${({ size = 'sm' }) => fromTheme('switch', 'track', 'margin', size, 'right')};
    flex-shrink: 0;
`;
SwitchWithMargin.displayName = 'SwitchWithMargin';

let ToggleOptions = styled(Text).attrs({ name: 'toggle-options' })`
    flex-grow: 0;
    color: ${({ selected }) => fromTheme('switch', 'options', 'color', selected ? 'selected' : 'unselected')};
    font-size: ${({ size = 'sm', selected }) =>
        fromTheme('switch', 'options', 'font', size, selected ? 'selected' : 'unselected', 'fontSize')};
    font-weight: ${({ size = 'sm', selected }) =>
        fromTheme('switch', 'options', 'font', size, selected ? 'selected' : 'unselected', 'fontWeight')};
`;
ToggleOptions = webOnlyStyles(ToggleOptions)`
    line-height: 1;
`;
ToggleOptions = nativeOnlyStyles(ToggleOptions)`
    line-height: ${({ size = 'sm', selected }) => fromTheme('switch', 'options', 'font', size, selected ? 'selected' : 'unselected', 'fontSize')};
`;
ToggleOptions.displayName = 'ToggleOptions';

const Title = styled(Text).attrs({ name: 'title' })`
    padding-right: ${fromTheme('textPaddingMore')};
    flex-grow: 1;
`;
Title.displayName = 'title';

export default function Toggle(props) {
    const { id, value, falseLabel, trueLabel, onClick, title, size = 'sm' } = props;
    // prettier-ignore
    return rc(SwitchLayout, {size, ...testProperties({id}, 'toggle')},
            title && rc(Title, null, title),
            falseLabel && rc(ToggleOptions, { selected: !value, size}, falseLabel),
            rc(SwitchWithMargin, {value, onClick, id, size, multistate: false }),
            trueLabel && rc(ToggleOptions, { selected: value, size}, trueLabel)
        );
}
